import {
    Checkbox, DefaultButton, getId, Icon, Modal, PrimaryButton, ProgressIndicator, TextField
} from "@fluentui/react";
import {
    defaultButtonStyles, primaryButtonStyles, textFieldStyles
} from "../../../common/views/DefaultStyles";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { EmailModel } from "../../models/EmailModel";

export type EmailEntryProps = {
    isEdit: boolean;
    form: EmailModel;
    errorMessages: any;
    submitting: boolean;
    onValueChange: (field: keyof EmailModel, value: any) => void;
    onSubmit: () => void;
    onClose: () => void;
}

export default function EmailEntryView({
    isEdit, form, errorMessages, submitting, onValueChange, onSubmit, onClose
}: EmailEntryProps) {
    const isMobile = window.innerWidth <= 500;
    const width6 = Utils.getColumnWidth(6);
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const addressInput = () => {
        return <>
            <TextField
                label="Address"
                value={form.address}
                onChange={(_, v) => onValueChange("address", v || "")}
                errorMessage={errorMessages.address}
                styles={textFieldStyles} />
        </>;
    }

    const isPrimaryCheckbox = () => {
        return <>
            <Checkbox
                label="Set Default?"
                checked={form.isPrimary}
                onChange={(_, v) => onValueChange("isPrimary", v || false)}
            />
        </>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row">
            <div className={width6}>
                <DefaultButton
                    onClick={onClose}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const modalHeader = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>
                        {isEdit && <>Edit Email: {form.id}</>}
                        {!isEdit && <>Add New Email</>}
                    </div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={true}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {modalHeader()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body ph-15"}>
                <div>{addressInput()}</div>
                <div className="pt-15">{isPrimaryCheckbox()}</div>

                {!submitting && <div className="pv-20">{buttons()}</div>}

                {submitting && <div className="pv-20">
                    <ProgressIndicator label="Submitting" description="" />
                </div>}
            </div>
        </Modal>
    </>;
}